import React from 'react';
import { Alert, Button, Paper, Typography } from '@mui/material';
import ThumbnailPicker from './thumbnails/ThumbnailPicker';
import useVideoThumbnail from './thumbnails/useVideoThumbnail';

export default function VideoThumbnailPanel({ kind, videoId, title }) {
  const saved = useVideoThumbnail(kind, videoId);
  return (
    <Paper
      component="section"
      aria-label="Video thumbnail"
      sx={{ p: 2, mb: 2, bgcolor: '#fff' }}
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.5 }}>
        Video thumbnail
      </Typography>
      <ThumbnailPicker
        loading={saved.loading}
        thumbnail={saved.thumbnail}
        title={title}
        onFiles={saved.change}
        onRemove={() => saved.change(null)}
        disabled={saved.loading}
        busy={saved.busy}
      />
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: 'block', mt: 1.5 }}
      >
        Saved per video. Uploads automatically when this video uploads to
        YouTube. You can also replace it after upload.
      </Typography>
      {saved.error && (
        <Alert
          severity="error"
          sx={{ mt: 1.5 }}
          action={<Button onClick={saved.reload}>Reload</Button>}
        >
          {saved.error}
        </Alert>
      )}
      {saved.notice && (
        <Alert severity="success" sx={{ mt: 1.5 }} onClose={saved.clearNotice}>
          {saved.notice}
        </Alert>
      )}
    </Paper>
  );
}
